import { type PropsWithChildren } from "react"
import { motion, type MotionProps } from "framer-motion"

export const FadeIn = ({
    children,
    delay,
    ...props
}: PropsWithChildren<MotionProps> & { delay?: number }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.9 }}
            transition={{
                duration: 1,
                delay: delay || 0,
            }}
            {...props}
        >
            {children}
        </motion.div>
    )
}
